//@flow
import type { ReducerState$Type,EditFormData } from './flowTypes'

export const transformDataToEditFormData=(data:any,eros: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const erosResultsetData = data['erosResultset']
    formData.isInvalidDoc = erosResultsetData['is_invalid_doc']?erosResultsetData['is_invalid_doc']:false
    formData.isDocAStatement = erosResultsetData['is_doc_a_statement']?erosResultsetData['is_doc_a_statement']:false
    formData.isOverrideVendorName = erosResultsetData['is_override_vendor_name']?erosResultsetData['is_override_vendor_name']:false

    if (erosResultsetData['inv_no']){
        formData.invNo = erosResultsetData['inv_no']
    }
    if (erosResultsetData['inv_date']){
        formData.invDate = erosResultsetData['inv_date']
    }
    if (erosResultsetData['due_date']){
        formData.dueDate = erosResultsetData['due_date']
    }
    if (erosResultsetData['po_no']){
        formData.poNo = erosResultsetData['po_no']
    }
    if (erosResultsetData['job_no']){
        formData.jobNo = erosResultsetData['job_no']
    }
    if (erosResultsetData['total']){
        formData.total = parseFloat(erosResultsetData['total'])//Convert it to number
    }
    if (erosResultsetData['vendor_name']){
        formData.vendorName = erosResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/eros/editFormData.js